/* Enoteca Kru · aggiunte al carrello (pagina e carrello laterale).
   In ogni elemento .kru-extra mostra: quanto manca alla spedizione gratuita,
   il conteggio del box componibile, la casella della confezione regalo
   «Personalizza la bottiglia» (etichetta col testo del cliente, 10 €)
   e la conferma dei 18 anni, obbligatoria prima di andare al pagamento. */
(function () {
  var SOGLIA_GRATIS = 10000;            // 100,00 € in centesimi
  var CONFEZIONE = 55826101567779;      // variante «Confezione regalo» 5 €
  var PERSONALIZZA = 55826365350179;    // variante «Bottiglia personalizzata» 10 €
  var CAMPO = 'Testo sull\'etichetta';
  var SERVIZI = [CONFEZIONE, PERSONALIZZA];
  var RACCOLTA_BOX = '/collections/componi-il-tuo-box/products.json?limit=250';
  var boxHandles = null;
  var CHIAVE_ETA = 'kru-maggiorenne';

  function maggiorenne() { try { return sessionStorage.getItem(CHIAVE_ETA) === '1'; } catch (e) { return !!window.__kruEta; } }
  function segnaMaggiorenne(si) { window.__kruEta = si; try { si ? sessionStorage.setItem(CHIAVE_ETA, '1') : sessionStorage.removeItem(CHIAVE_ETA); } catch (e) {} }

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function euro(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function caricaBox() {
    if (boxHandles) return Promise.resolve(boxHandles);
    return fetch(RACCOLTA_BOX).then(function (r) { return r.json(); }).then(function (d) {
      boxHandles = {};
      (d.products || []).forEach(function (p) { boxHandles[p.handle] = true; });
      return boxHandles;
    }).catch(function () { boxHandles = {}; return boxHandles; });
  }

  function html(cart, box) {
    var confezione = cart.items.filter(function (i) { return i.variant_id === CONFEZIONE; })[0];
    var etichetta = cart.items.filter(function (i) { return i.variant_id === PERSONALIZZA; })[0];
    var testoEtichetta = etichetta && etichetta.properties ? (etichetta.properties[CAMPO] || '') : '';
    var totaleMerce = cart.items.reduce(function (s, i) { return SERVIZI.indexOf(i.variant_id) > -1 ? s : s + i.final_line_price; }, 0);
    var bottiglieBox = cart.items.reduce(function (s, i) { return box[i.handle] ? s + i.quantity : s; }, 0);
    var out = '';

    if (totaleMerce > 0) {
      var pct = Math.min(100, Math.round(totaleMerce / SOGLIA_GRATIS * 100));
      out += '<div class="kru-riga">' + (totaleMerce >= SOGLIA_GRATIS
        ? '<strong>La spedizione è gratuita.</strong>'
        : 'Ti mancano <strong>' + euro(SOGLIA_GRATIS - totaleMerce) + '</strong> per la spedizione gratuita.')
        + '<span class="kru-barra"><i style="width:' + pct + '%"></i></span></div>';
    }

    if (bottiglieBox > 0) {
      var testo = bottiglieBox >= 6 ? 'hai il <strong>10% di sconto</strong> sul box.'
        : bottiglieBox >= 3 ? 'hai il <strong>5% di sconto</strong>. Arriva a 6 e passi al 10%.'
        : 'con 3 hai il 5% di sconto, con 6 il 10%.';
      out += '<div class="kru-riga">Il tuo box: <strong>' + bottiglieBox + (bottiglieBox === 1 ? ' bottiglia' : ' bottiglie') + '</strong>, ' + testo
        + ' <a href="/collections/componi-il-tuo-box">Aggiungi vini</a></div>';
    }

    if (totaleMerce > 0) {
      out += '<label class="kru-regalo"><input type="checkbox" class="kru-regalo-check"' + (confezione ? ' checked' : '') + '>'
        + '<span><strong>Aggiungi la confezione regalo · 5 €</strong><br>Incartiamo a mano il tuo ordine con carta e nastro, pronto da regalare.</span></label>';

      out += '<div class="kru-etichetta' + (etichetta ? ' kru-salvata' : '') + '">'
        + '<label class="kru-regalo"><input type="checkbox" class="kru-etichetta-check"' + (etichetta ? ' checked' : '') + '>'
        + '<span><strong>Personalizza la bottiglia · 10 €</strong><br>Stampiamo il tuo testo su un\'etichetta Enoteca Kru e la mettiamo su una bottiglia del tuo ordine.'
        + (etichetta ? '<br><em class="kru-etichetta-mostra">«' + esc(testoEtichetta) + '»</em> <a href="#" class="kru-etichetta-modifica">Modifica</a>' : '') + '</span></label>'
        + '<div class="kru-etichetta-campo"><textarea class="kru-etichetta-testo" maxlength="80" rows="2" placeholder="Buon compleanno Marco! 40 anni e non sentirli">' + esc(testoEtichetta) + '</textarea>'
        + '<small>Massimo 80 caratteri, su due righe. Per più bottiglie o per un evento: <a href="/pages/personalizza">chiedi un preventivo</a>.</small>'
        + '<button type="button" class="kru-etichetta-salva">' + (etichetta ? 'Salva il testo' : 'Aggiungi · 10 €') + '</button></div></div>';

      out += '<label class="kru-eta"><input type="checkbox" class="kru-eta-check"' + (maggiorenne() ? ' checked' : '') + '>'
        + '<span>Confermo di avere <strong>almeno 18 anni</strong>. La vendita di alcolici è riservata ai maggiorenni.</span></label>';
    }
    return out;
  }

  // i pulsanti di pagamento rapido (Shop Pay, PayPal…) restano spenti finché non c'è la conferma
  function aggiornaPagamenti() {
    var ok = maggiorenne();
    document.querySelectorAll('.additional_checkout_buttons, .cart__additional_checkout').forEach(function (b) { b.classList.toggle('kru-bloccato', !ok); });
  }

  function disegna() {
    var posti = document.querySelectorAll('.kru-extra');
    if (!posti.length) return;
    Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), caricaBox()]).then(function (v) {
      var contenuto = html(v[0], v[1]);
      posti.forEach(function (p) { if (p.innerHTML !== contenuto) p.innerHTML = contenuto; });
      aggiornaPagamenti();
    });
  }

  function invia(url, corpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo) })
      .then(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('kru-etichetta-check')) return;
    var box = e.target.closest('.kru-etichetta');
    if (e.target.checked) {
      box.classList.add('kru-aperta');
      box.querySelector('.kru-etichetta-testo').focus();
    } else if (box.classList.contains('kru-salvata')) {
      e.target.disabled = true;
      invia('/cart/change.js', { id: String(PERSONALIZZA), quantity: 0 });
    } else {
      box.classList.remove('kru-aperta');
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('kru-etichetta-modifica')) {
      e.preventDefault();
      t.closest('.kru-etichetta').classList.add('kru-aperta');
      return;
    }
    if (!t.classList || !t.classList.contains('kru-etichetta-salva')) return;
    var box = t.closest('.kru-etichetta');
    var campo = box.querySelector('.kru-etichetta-testo');
    var testo = campo.value.trim();
    if (!testo) { campo.focus(); campo.classList.add('kru-manca'); return; }
    t.disabled = true;
    var proprieta = {}; proprieta[CAMPO] = testo;
    if (box.classList.contains('kru-salvata')) invia('/cart/change.js', { id: String(PERSONALIZZA), quantity: 1, properties: proprieta });
    else invia('/cart/add.js', { items: [{ id: PERSONALIZZA, quantity: 1, properties: proprieta }] });
  });

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('kru-eta-check')) return;
    segnaMaggiorenne(e.target.checked);
    document.querySelectorAll('.kru-eta-check').forEach(function (c) { c.checked = e.target.checked; });
    document.querySelectorAll('.kru-eta').forEach(function (l) { l.classList.remove('kru-manca'); });
    aggiornaPagamenti();
  });

  // al pagamento si va solo con la conferma dei 18 anni
  document.addEventListener('submit', function (e) {
    var chi = e.submitter;
    if (!chi || chi.name !== 'checkout' || maggiorenne()) return;
    e.preventDefault();
    var riga = (e.target.querySelector('.kru-eta') || document.querySelector('.kru-eta'));
    if (riga) { riga.classList.add('kru-manca'); riga.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('kru-regalo-check')) return;
    e.target.disabled = true;
    var richiesta = e.target.checked
      ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: CONFEZIONE, quantity: 1 }] }) })
      : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(CONFEZIONE), quantity: 0 }) });
    richiesta.then(function () { window.location.reload(); });
  });

  // il carrello laterale viene ricostruito dal tema: ridisegno quando compare un .kru-extra vuoto
  var attesa = null;
  new MutationObserver(function () {
    var vuoti = [].some.call(document.querySelectorAll('.kru-extra'), function (p) { return !p.innerHTML.trim(); });
    if (vuoti) { clearTimeout(attesa); attesa = setTimeout(disegna, 150); }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', disegna);
})();
